import { FormProvider } from 'react-hook-form';
import { useCreateActivationForm } from './hooks';
import { CreateActivationFormPresentation } from './presentations';

/**
 * アクティベーション追加フォームのコンテナコンポーネント
 * NOTE: Suspenseを使用するhookを含むため、親コンポーネントでSuspenseでラップしてください
 */
export const CreateActivationForm: React.FC = () => {
  const {
    state: { methods, isButtonDisabled, searchAction },
    actions: { handleOnSubmit, handleClientChange },
  } = useCreateActivationForm();

  return (
    <FormProvider {...methods}>
      <CreateActivationFormPresentation
        isButtonDisabled={isButtonDisabled}
        searchAction={searchAction}
        onClientChange={handleClientChange}
        onSubmit={handleOnSubmit}
      />
    </FormProvider>
  );
};
